export const loggerService = {
	trackPageView,
	trackEvent,
	trackException,
	trackTrace,
	getLoggerSettings
};

// get setting from session; otherwise from environment variables
function getLoggerSettings() {

	// check if settings are in session
	const logger = sessionStorage.getItem('logger');

	// read from environment variables and add to session
	if (logger === 'undefined' || logger == null || logger === 'null') {
		const environmentSettings = {
			consolePageView: JSON.parse(process.env.REACT_APP_ENABLE_LOGS_TRACK_PAGE_VIEW_CONSOLE || true),
			consoleEvent: JSON.parse(process.env.REACT_APP_ENABLE_LOGS_TRACK_EVENT_CONSOLE || true),
			consoleException: JSON.parse(process.env.REACT_APP_ENABLE_LOGS_TRACK_EXCEPTION_CONSOLE || true),
			consoleTrace: JSON.parse(process.env.REACT_APP_ENABLE_LOGS_TRACK_TRACE_CONSOLE || true)
		};

		sessionStorage.setItem('logger', JSON.stringify(environmentSettings));
		return environmentSettings;
	} else {
		return JSON.parse(logger);
	}
}

// Logs that a page, or similar container was displayed to the user.
function trackPageView(name, url) {
	const logger = getLoggerSettings();
	if (logger?.consolePageView) {
		console.log({ name: name, uri: url, date: new Date().toLocaleString() });
	}
}

// Log a user action or other occurrence
function trackEvent(name, properties) {
	const logger = getLoggerSettings();
	if (logger?.consoleEvent) {
		console.log({ name: name, properties: JSON.stringify(properties), date: new Date().toLocaleString() });
	}
}

// Log an exception that you have caught.
// Verbose = 0, Information = 1, Warning = 2, Error = 3, Critical = 4
function trackException(exception, properties, severityLevel = 3) {
	const logger = getLoggerSettings();
	if (logger?.consoleException) {
		console.error({ exception: exception, severityLevel: severityLevel, properties: JSON.stringify(properties), date: new Date().toLocaleString() });
	}
}

// Log a diagnostic scenario such entering or leaving a function
function trackTrace(message, properties) {
	const logger = getLoggerSettings();
	if (logger?.consoleTrace) {
		console.log({ message: message, properties: JSON.stringify(properties), date: new Date().toLocaleString() });
	}
}
